import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'

import { deliveryPerformanceQueryClient } from 'queryClients/deliveryPerformance'

import { useDeliveryPerformanceDetailController } from './hooks/useDeliveryPerformanceDetailController'
import { useSelectedWarehouseTenantNames } from './hooks/useSelectedWarehouseTenantNames'
import { DeliveryPerformanceDetailHeader } from './components/DeliveryPerformanceDetailHeader'
import { DeliveryPerformanceDetailView } from './components/DeliveryPerformanceDetailView'

const DeliveryPerformanceDetailPageInner: React.FC = () => {
  const controller = useDeliveryPerformanceDetailController()
  const { warehouseName, tenantName } = useSelectedWarehouseTenantNames()

  return (
    <>
      <DeliveryPerformanceDetailHeader warehouseName={warehouseName} tenantName={tenantName} />
      <DeliveryPerformanceDetailView {...controller} />
    </>
  )
}

export const DeliveryPerformanceDetailPage: React.FC = () => (
  <QueryClientProvider client={deliveryPerformanceQueryClient}>
    <DeliveryPerformanceDetailPageInner />
  </QueryClientProvider>
)
